import React from "react";
import CloneRepo from "../CodeOverview/CloneRepo.jsx";

function BusinessRequirements() {


  return (
    <>
      <CloneRepo />
    </>
  );
}

export default BusinessRequirements;